export default __webpack_public_path__ + "static/media/profile-pic2.8c2e7f71.jpg";